import { render, staticRenderFns } from "./customerrecord.vue?vue&type=template&id=6d7eaf92&scoped=true"
import script from "./customerrecord.vue?vue&type=script&lang=js"
export * from "./customerrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7eaf92",
  null
  
)

export default component.exports